<nav [ngClass]="{'sidebar second-sidebar' : true, 'hide-sidebar' : mode == 'filtres'}">
    <ul class="list-unstyled components"
        [stepContent]="cityFilterTabsStepContent"
        [joyrideStep]="'cityFilterTabsStep'">
        <li>
            <a [ngClass]="{'active': currentTab == 'city_include'}"
               (click)="currentTab = 'city_include';mode = 'filtres'">
                <b><i class="icon search_zone"></i> Villes à inclure</b>
                <i class="fa fa-chevron-right float-right text-primary"></i>
                <p class="text-primary">
                    <span *ngFor="let city of cities_include | slice:0:3; index as icity">
                        {{ city.name }}<ng-container *ngIf="icity < (cities_include | slice:0:3).length - 1">, </ng-container>
                    </span>
                    <span *ngIf="cities_include.length > 3"> + {{ cities_include.length - 3 }} autres villes</span>
                </p>
            </a>
        </li>
        <li>
            <a [ngClass]="{'active': currentTab == 'city_exclude'}" (click)="currentTab = 'city_exclude';mode = 'filtres'">
                <b><i class="icon search_zone_exclude"></i> Villes à exclure</b>
                <i class="fa fa-chevron-right float-right text-primary"></i>
                <p>
                    <span *ngFor="let city of cities_exclude | slice:0:3; index as icity">
                        {{ city.name }}<ng-container *ngIf="icity < (cities_exclude | slice:0:3).length - 1">, </ng-container>
                    </span>
                    <span *ngIf="cities_exclude.length > 3"> + {{ cities_exclude.length - 3 }} autres villes</span>
                </p>
            </a>
        </li>
        <li>
            <a [ngClass]="{'active': currentTab == 'localisation'}"
               (click)="currentTab = 'localisation';mode = 'filtres'">
                <b><i class="icon icon-ville"></i> Localisation</b>
                <i class="fa fa-chevron-right float-right text-primary"></i>
            </a>
        </li>
        <li
            [stepContent]="cityFilterSocioStepContent"
            [joyrideStep]="'cityFilterSocioStep'">
            <a [ngClass]="{'active': currentTab == 'demographie'}"
               (click)="currentTab = 'demographie';mode = 'filtres'">
                <b><i class="icon icon-copro"></i> Filtres socio-démographiques</b>
                <i class="fa fa-chevron-right float-right text-primary"></i>
            </a>
        </li>
        <li
            [stepContent]="cityFilterImmoStepContent"
            [joyrideStep]="'cityFilterImmoStep'">
            <a [ngClass]="{'active': currentTab == 'market'}"
               (click)="currentTab = 'market';mode = 'filtres'">
                <b><i class="icon invest"></i> Marché immobilier</b>
                <i class="fa fa-chevron-right float-right text-primary"></i>
            </a>
        </li>
        <li>
            <a [ngClass]="{'active': currentTab == 'price_evol'}"
               (click)="currentTab = 'price_evol';mode = 'filtres'">
                <b><i class="icon search_budget"></i> Évolution des prix</b>
                <i class="fa fa-chevron-right float-right text-primary"></i>
            </a>
        </li>
    </ul>

    <div class="container-fluid filters-actions">
        <p class="filters-count text-center text-grey" *ngIf="citiesCount != null">
            Votre recherche comporte {{ citiesCount | number }} ville{{ citiesCount > 1 ? 's' : '' }}
        </p>
        <div class="d-flex justify-content-between gap-3">
            <button class="btn btn-lg btn-outline" type="button" (click)="resetAllFilters()">
                <i class="fa fa-refresh"></i> Tout effacer
            </button>
            <button class="btn btn-lg" type="button" (click)="search()"
                    [stepContent]="cityFilterValidateStepContent"
                    [joyrideStep]="'cityFilterValidateStep'">
                <i class="fa fa-search"></i> Rechercher
            </button>
        </div>
    </div>
</nav>

<div id="content-second-sidebar">
    <div class="container-fluid">
        <div class="row h1_row">
            <div class="col-sm-8 col-11">
                <h1>
                    {{ (this.currentSearch != undefined && this.currentSearch.title !== undefined && this.currentSearch.title !== '' ? 'Votre secteur ' + this.currentSearch.title : 'Nouveau secteur de recherche') }}
                    <span>Trouvez les meilleures villes où investir</span>
                </h1>
            </div>
            <div class="col-sm-4 col-1">
                <p class="btn btn-outline btn-tool float-right  mobile-icon mt-4" (click)="openTuto()">
                    <img src="assets/icons/yt.png"  class="n-size"alt=""/><span>Tutoriel : Mes secteurs</span>
                </p>
            </div>
        </div>

        <div [ngClass]="{'main-card': true, 'hide-content-sidebar' : mode == 'sidebar'}" id="searchForm">
            <!-- Bandeau de la section ouverte : retour aux catégories + nom de la section
                 (masqué en desktop 3 colonnes, où les deux volets sont visibles) -->
            <div class="filters-section-bar">
                <a class="filters-section-back" (click)="mode = 'sidebar'" aria-label="Retour aux filtres">
                    <i class="fa fa-angle-left"></i>
                </a>
                <span class="filters-section-title">{{ getTabLabel() }}</span>
            </div>
            <form [formGroup]="searchForm">
                <!-- MOBILE : paire de champs Min / Max branchée sur le même contrôle que le slider -->
                <ng-template #rangeInputsTpl let-control="control" let-suffix="suffix" let-locked="locked">
                    <div class="row" [class.range-locked]="locked" (click)="locked && unlock()">
                        <div class="col-6 pe-0">
                            <mat-form-field>
                                <mat-label>Min</mat-label>
                                <input matInput type="number" [ngModel]="getRangeBoundDisplay(control, 0)"
                                       [ngModelOptions]="{standalone: true}"
                                       (ngModelChange)="setRangeBound(control, 0, $event)" [disabled]="locked">
                                <span matSuffix> {{ suffix }}</span>
                            </mat-form-field>
                        </div>
                        <div class="col-6">
                            <mat-form-field>
                                <mat-label>Max</mat-label>
                                <input matInput type="number" [ngModel]="getRangeBoundDisplay(control, 1)"
                                       [ngModelOptions]="{standalone: true}"
                                       (ngModelChange)="setRangeBound(control, 1, $event)" [disabled]="locked">
                                <span matSuffix> {{ suffix }}</span>
                            </mat-form-field>
                        </div>
                    </div>
                </ng-template>
                <div class="card" [hidden]="currentTab != 'city_include'">
                    <div class="row">
                        <div class="col-12">
                            <h2>Villes à inclure</h2>
                        </div>
                        <div class="col-12 col-md-6"
                             [stepContent]="cityFilterCityStepContent"
                             [joyrideStep]="'cityFilterCityStep'"
                             (next)="currentTab = 'localisation'">
                            <mat-form-field>
                                <mat-label>Ville</mat-label>
                                <input type="text" class="text" matInput formControlName="cityIncludeControl"
                                       [matAutocomplete]="autoZipcodeInclude">
                                <span matPrefix>
                                    <img class="me-2" src="assets/icons/city.svg" alt="" />
                                </span>
                                <mat-autocomplete (optionSelected)='addCity($event.option.value, "include")'
                                                  [displayWith]="commonService.cityLabel" autoActiveFirstOption
                                                  #autoZipcodeInclude="matAutocomplete">
                                    <mat-option *ngFor="let city of zipCode" [value]="city">
                                        {{ city.name }}
                                        <ng-container *ngIf="city.type != 'global'">({{ city.display_zip_code == '' ? city.zip_code : city.display_zip_code.includes(',') ? 'Toute la ville' : city.display_zip_code }})</ng-container>
                                    </mat-option>
                                </mat-autocomplete>
                                <span matSuffix>
                                        <div class="citySpinner">
                                            <mat-spinner diameter="20"></mat-spinner>
                                        </div>
                                    </span>
                            </mat-form-field>
                        </div>
                        <!-- Même colonne (centrée) que le champ d'ajout : les rangées s'alignent dessous -->
                        <div class="col-12 col-md-6">
                            <div class="city-wrap">
                                <p *ngFor="let city of cities_include">
                                    {{ city.name }}
                                    <ng-container *ngIf="city.type != 'global'">({{ city.display_zip_code == '' ? city.zip_code : city.display_zip_code.includes(',') ? 'Toute la ville' : city.display_zip_code }})</ng-container>
                                    <i class="fa fa-remove" (click)="removeCity(city, 'include')"></i>
                                    <!-- Rayon autour de la ville : slider (le libellé suit le drag, rechargement au relâchement) -->
                                    <span class="city-km-row d-flex align-items-center">
                                        <span class="km-label">Rayon : {{ city.km || 0 }} km</span>
                                        <ngx-slider [value]="city.km || 0" [options]="kmSliderOptions"
                                                    (valueChange)="city.km = $event"
                                                    (userChangeEnd)="city.km = $event.value; loadCities()"></ngx-slider>
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card" [hidden]="currentTab != 'city_exclude'">
                    <div class="row">
                        <div class="col-12">
                            <h2>Villes à exclure</h2>
                        </div>
                        <div class="col-12 col-md-6">
                            <mat-form-field>
                                <mat-label>Ville</mat-label>
                                <input type="text" class="text" matInput formControlName="cityExcludeControl"
                                       [matAutocomplete]="autoZipcodeExclude">
                                <span matPrefix>
                                    <img class="me-2" src="assets/icons/city.svg" alt="" />
                                </span>
                                <mat-autocomplete (optionSelected)='addCity($event.option.value, "exclude")'
                                                  [displayWith]="commonService.cityLabel" autoActiveFirstOption
                                                  #autoZipcodeExclude="matAutocomplete">
                                    <mat-option *ngFor="let city of zipCode" [value]="city">
                                        {{ city.name }}
                                        <ng-container *ngIf="city.type != 'global'">({{ city.display_zip_code == '' ? city.zip_code : city.display_zip_code.includes(',') ? 'Toute la ville' : city.display_zip_code }})</ng-container>
                                    </mat-option>
                                </mat-autocomplete>
                                <span matSuffix>
                                        <div class="citySpinner">
                                            <mat-spinner diameter="20"></mat-spinner>
                                        </div>
                                    </span>
                            </mat-form-field>
                        </div>
                        <!-- Même colonne (centrée) que le champ d'ajout : les rangées s'alignent dessous -->
                        <div class="col-12 col-md-6">
                            <div class="city-wrap">
                                <p *ngFor="let city of cities_exclude" class="text-red">
                                    {{ city.name }}
                                    <ng-container *ngIf="city.type != 'global'">({{ city.display_zip_code == '' ? city.zip_code : city.display_zip_code.includes(',') ? 'Toute la ville' : city.display_zip_code }})</ng-container>
                                    <i class="fa fa-remove" (click)="removeCity(city, 'exclude')"></i>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card" [hidden]="currentTab != 'localisation'">
                    <div class="row">
                        <div class="col-12">
                            <h2>Localisation</h2>
                        </div>
                        <div class="col-12 col-md-6"
                             [stepContent]="cityFilterLocalisationStepContent"
                             [joyrideStep]="'cityFilterLocalisationStep'"
                             (prev)="currentTab = 'city_include'"
                             (next)="currentTab = 'city_include'">
                            <mat-form-field class="filter" floatLabel="never">
                                <mat-select disableOptionCentering panelClass="mobile-sheet-select" formControlName="region" multiple placeholder="Région"
                                            (selectionChange)="loadCities()">
                                    <mat-option value="Auvergne-Rhône-Alpes">Auvergne-Rhône-Alpes
                                    </mat-option>
                                    <mat-option value="Bourgogne-Franche-Comté">Bourgogne-Franche-Comté
                                    </mat-option>
                                    <mat-option value="Bretagne">Bretagne</mat-option>
                                    <mat-option value="Centre-Val de Loire">Centre-Val de Loire
                                    </mat-option>
                                    <mat-option value="Corse">Corse</mat-option>
                                    <mat-option value="Grand Est">Grand Est</mat-option>
                                    <mat-option value="Guadeloupe">Guadeloupe</mat-option>
                                    <mat-option value="Guyane">Guyane</mat-option>
                                    <mat-option value="Hauts-de-France">Hauts-de-France</mat-option>
                                    <mat-option value="Ile-de-France">Ile-de-France</mat-option>
                                    <mat-option value="La Réunion">La Réunion</mat-option>
                                    <mat-option value="Martinique">Martinique</mat-option>
                                    <mat-option value="Mayotte">Mayotte</mat-option>
                                    <mat-option value="Normandie">Normandie</mat-option>
                                    <mat-option value="Nouvelle-Aquitaine">Nouvelle-Aquitaine
                                    </mat-option>
                                    <mat-option value="Occitanie">Occitanie</mat-option>
                                    <mat-option value="Pays de la Loire">Pays de la Loire</mat-option>
                                    <mat-option value="Provence-Alpes-Côte d'Azur">Provence-Alpes-Côte
                                        d'Azur
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                            <mat-form-field class="filter" floatLabel="never">
                                <mat-select disableOptionCentering panelClass="mobile-sheet-select" formControlName="departement" multiple
                                            placeholder="Département" (selectionChange)="loadCities()">
                                    <mat-option value="Ain">01 - Ain</mat-option>
                                    <mat-option value="Aisne">02 - Aisne</mat-option>
                                    <mat-option value="Allier">03 - Allier</mat-option>
                                    <mat-option value="Alpes-de-Haute-Provence">04 -
                                        Alpes-de-Haute-Provence
                                    </mat-option>
                                    <mat-option value="Hautes-Alpes">05 - Hautes-Alpes</mat-option>
                                    <mat-option value="Alpes-Maritimes">06 - Alpes-Maritimes
                                    </mat-option>
                                    <mat-option value="Ardèche">07 - Ardèche</mat-option>
                                    <mat-option value="Ardennes">08 - Ardennes</mat-option>
                                    <mat-option value="Ariège">09 - Ariège</mat-option>
                                    <mat-option value="Aube">10 - Aube</mat-option>
                                    <mat-option value="Aude">11 - Aude</mat-option>
                                    <mat-option value="Aveyron">12 - Aveyron</mat-option>
                                    <mat-option value="Bouches-du-Rhône">13 - Bouches-du-Rhône
                                    </mat-option>
                                    <mat-option value="Calvados">14 - Calvados</mat-option>
                                    <mat-option value="Cantal">15 - Cantal</mat-option>
                                    <mat-option value="Charente">16 - Charente</mat-option>
                                    <mat-option value="Charente-Maritime">17 - Charente-Maritime
                                    </mat-option>
                                    <mat-option value="Cher">18 - Cher</mat-option>
                                    <mat-option value="Corrèze">19 - Corrèze</mat-option>
                                    <mat-option value="Corse-du-Sud">2A - Corse-du-Sud</mat-option>
                                    <mat-option value="Haute-Corse">2B - Haute-Corse</mat-option>
                                    <mat-option value="Côte-d'Or">21 - Côte-d'Or</mat-option>
                                    <mat-option value="Côtes d'Armor">22 - Côtes d'Armor</mat-option>
                                    <mat-option value="Creuse">23 - Creuse</mat-option>
                                    <mat-option value="Dordogne">24 - Dordogne</mat-option>
                                    <mat-option value="Doubs">25 - Doubs</mat-option>
                                    <mat-option value="Drôme">26 - Drôme</mat-option>
                                    <mat-option value="Eure">27 - Eure</mat-option>
                                    <mat-option value="Eure-et-Loir">28 - Eure-et-Loir</mat-option>
                                    <mat-option value="Finistère">29 - Finistère</mat-option>
                                    <mat-option value="Gard">30 - Gard</mat-option>
                                    <mat-option value="Haute-Garonne">31 - Haute-Garonne</mat-option>
                                    <mat-option value="Gers">32 - Gers</mat-option>
                                    <mat-option value="Gironde">33 - Gironde</mat-option>
                                    <mat-option value="Hérault">34 - Hérault</mat-option>
                                    <mat-option value="Ille-et-Vilaine">35 - Ille-et-Vilaine
                                    </mat-option>
                                    <mat-option value="Indre">36 - Indre</mat-option>
                                    <mat-option value="Indre-et-Loire">37 - Indre-et-Loire</mat-option>
                                    <mat-option value="Isère">38 - Isère</mat-option>
                                    <mat-option value="Jura">39 - Jura</mat-option>
                                    <mat-option value="Landes">40 - Landes</mat-option>
                                    <mat-option value="Loir-et-Cher">41 - Loir-et-Cher</mat-option>
                                    <mat-option value="Loire">42 - Loire</mat-option>
                                    <mat-option value="Haute-Loire">43 - Haute-Loire</mat-option>
                                    <mat-option value="Loire-Atlantique">44 - Loire-Atlantique
                                    </mat-option>
                                    <mat-option value="Loiret">45 - Loiret</mat-option>
                                    <mat-option value="Lot">46 - Lot</mat-option>
                                    <mat-option value="Lot-et-Garonne">47 - Lot-et-Garonne</mat-option>
                                    <mat-option value="Lozère">48 - Lozère</mat-option>
                                    <mat-option value="Maine-et-Loire">49 - Maine-et-Loire</mat-option>
                                    <mat-option value="Manche">50 - Manche</mat-option>
                                    <mat-option value="Marne">51 - Marne</mat-option>
                                    <mat-option value="Haute-Marne">52 - Haute-Marne</mat-option>
                                    <mat-option value="Mayenne">53 - Mayenne</mat-option>
                                    <mat-option value="Meurthe-et-Moselle">54 - Meurthe-et-Moselle
                                    </mat-option>
                                    <mat-option value="Meuse">55 - Meuse</mat-option>
                                    <mat-option value="Morbihan">56 - Morbihan</mat-option>
                                    <mat-option value="Moselle">57 - Moselle</mat-option>
                                    <mat-option value="Nièvre">58 - Nièvre</mat-option>
                                    <mat-option value="Nord">59 - Nord</mat-option>
                                    <mat-option value="Oise">60 - Oise</mat-option>
                                    <mat-option value="Orne">61 - Orne</mat-option>
                                    <mat-option value="Pas-de-Calais">62 - Pas-de-Calais</mat-option>
                                    <mat-option value="Puy-de-Dôme">63 - Puy-de-Dôme</mat-option>
                                    <mat-option value="Pyrénées-Atlantiques">64 - Pyrénées-Atlantiques
                                    </mat-option>
                                    <mat-option value="Hautes-Pyrénées">65 - Hautes-Pyrénées
                                    </mat-option>
                                    <mat-option value="Pyrénées-Orientales">66 - Pyrénées-Orientales
                                    </mat-option>
                                    <mat-option value="Bas-Rhin">67 - Bas-Rhin</mat-option>
                                    <mat-option value="Haut-Rhin">68 - Haut-Rhin</mat-option>
                                    <mat-option value="Rhône">69 - Rhône</mat-option>
                                    <mat-option value="Haute-Saône">70 - Haute-Saône</mat-option>
                                    <mat-option value="Saône-et-Loire">71 - Saône-et-Loire</mat-option>
                                    <mat-option value="Sarthe">72 - Sarthe</mat-option>
                                    <mat-option value="Savoie">73 - Savoie</mat-option>
                                    <mat-option value="Haute-Savoie">74 - Haute-Savoie</mat-option>
                                    <mat-option value="Paris">75 - Paris</mat-option>
                                    <mat-option value="Seine-Maritime">76 - Seine-Maritime</mat-option>
                                    <mat-option value="Seine-et-Marne">77 - Seine-et-Marne</mat-option>
                                    <mat-option value="Yvelines">78 - Yvelines</mat-option>
                                    <mat-option value="Deux-Sèvres">79 - Deux-Sèvres</mat-option>
                                    <mat-option value="Somme">80 - Somme</mat-option>
                                    <mat-option value="Tarn">81 - Tarn</mat-option>
                                    <mat-option value="Tarn-et-Garonne">82 - Tarn-et-Garonne
                                    </mat-option>
                                    <mat-option value="Var">83 - Var</mat-option>
                                    <mat-option value="Vaucluse">84 - Vaucluse</mat-option>
                                    <mat-option value="Vendée">85 - Vendée</mat-option>
                                    <mat-option value="Vienne">86 - Vienne</mat-option>
                                    <mat-option value="Haute-Vienne">87 - Haute-Vienne</mat-option>
                                    <mat-option value="Vosges">88 - Vosges</mat-option>
                                    <mat-option value="Yonne">89 - Yonne</mat-option>
                                    <mat-option value="Territoire-de-Belfort">90 - Territoire-de-Belfort
                                    </mat-option>
                                    <mat-option value="Essonne">91 - Essonne</mat-option>
                                    <mat-option value="Hauts-de-Seine">92 - Hauts-de-Seine</mat-option>
                                    <mat-option value="Seine-Saint-Denis">93 - Seine-Saint-Denis
                                    </mat-option>
                                    <mat-option value="Val-de-Marne">94 - Val-de-Marne</mat-option>
                                    <mat-option value="Val-D'Oise">95 - Val-D'Oise</mat-option>
                                    <mat-option value="Guadeloupe">97 - Guadeloupe</mat-option>
                                    <mat-option value="Martinique">97 - Martinique</mat-option>
                                    <mat-option value="Guyane">97 - Guyane</mat-option>
                                    <mat-option value="La Réunion">97 - La Réunion</mat-option>
                                    <mat-option value="Mayotte">97 - Mayotte</mat-option>
                                </mat-select>
                            </mat-form-field>

                            <mat-checkbox formControlName="coeur_de_ville">
                                Plan "Action cœur de ville"
                            </mat-checkbox>
                            <br/>
                            <br/>

                            <mat-checkbox formControlName="denormandie">
                                Petites Villes de Demain (Éligible Denormandie)
                            </mat-checkbox>
                        </div>
                    </div>
                </div>

                <div class="card" [hidden]="currentTab != 'demographie'">
                    <div class="row">
                        <div class="col-12 col-md-6">
                            <h2>Population
                                <i class="fa fa-lock" (click)="unlock()"
                                   *ngIf="optionsPop.disabled"></i>
                            </h2>
                            <ng-container *ngTemplateOutlet="rangeInputsTpl; context: {control: 'pop', suffix: 'hab', locked: optionsPop.disabled}"></ng-container>
                        </div>
                        <div class="col-12 col-md-6">
                            <h2>Taux de chômage
                                <i class="fa fa-lock" (click)="unlock()" *ngIf="optionsTc.disabled"></i></h2>
                            <ng-container *ngTemplateOutlet="rangeInputsTpl; context: {control: 'tc', suffix: '%', locked: optionsTc.disabled}"></ng-container>
                        </div>
                        <div class="col-12 col-md-6">
                            <h2>Taux d'étudiants
                                <i class="fa fa-lock" (click)="unlock()"
                                   *ngIf="optionsTe.disabled"></i>
                            </h2>
                            <ng-container *ngTemplateOutlet="rangeInputsTpl; context: {control: 'te', suffix: '%', locked: optionsTe.disabled}"></ng-container>
                        </div>
                        <div class="col-12 col-md-6">
                            <h2>Taux de logements vacants
                                <i class="fa fa-lock" (click)="unlock()"
                                   *ngIf="optionsTv.disabled"></i>
                            </h2>
                            <ng-container *ngTemplateOutlet="rangeInputsTpl; context: {control: 'tv', suffix: '%', locked: optionsTv.disabled}"></ng-container>
                        </div>
                        <div class="col-12 col-md-6">
                            <h2>Niveau de vie moyen/hab
                                <i class="fa fa-lock" (click)="unlock()"
                                   *ngIf="optionsMv.disabled"></i>
                            </h2>
                            <ng-container *ngTemplateOutlet="rangeInputsTpl; context: {control: 'mv', suffix: '€', locked: optionsMv.disabled}"></ng-container>
                        </div>
                        <div class="col-12 col-md-6">
                            <h2>Croissance démographique
                                <i class="fa fa-lock" (click)="unlock()"
                                   *ngIf="!authenticationService.isAllowed('essentiel')"></i>
                            </h2>
                            <!-- Liste à cocher standard du site (comme Type de bien / Atouts) -->
                            <div class="type-menu-check">
                                <a class="type-option" *ngFor="let opt of evolDemoOptions"
                                   [class.active]="isEvolDemoSelected(opt.value)"
                                   (click)="toggleEvolDemo(opt.value)">
                                    <span class="type-option-label">{{ opt.label }}</span>
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card" [hidden]="currentTab != 'market'">
                    <div class="row">
                        <div class="col-12 col-md-6">
                            <h2>Facilité à trouver une location
                                <i matTooltip="Côté locataire. Très difficile = Grosse demande locative / Très facile : Demande locative faible."
                                   class="fa fa-question-circle"></i>

                                <i class="fa fa-lock" (click)="unlock()"
                                   *ngIf="optionsTensiometre.disabled"></i>
                            </h2>
                            <div class="row" [class.range-locked]="optionsTensiometre.disabled"
                                 (click)="optionsTensiometre.disabled && unlock()">
                                <div class="col-6 pe-0">
                                    <mat-form-field>
                                        <mat-label>Min</mat-label>
                                        <mat-select disableOptionCentering panelClass="mobile-sheet-select"
                                                    [ngModel]="getTensiometreBound(0)"
                                                    [ngModelOptions]="{standalone: true}"
                                                    (ngModelChange)="setTensiometreBound(0, $event)"
                                                    [disabled]="optionsTensiometre.disabled">
                                            <mat-option *ngFor="let o of tensiometreMinOptions" [value]="o.value">{{ o.label }}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div class="col-6">
                                    <mat-form-field>
                                        <mat-label>Max</mat-label>
                                        <mat-select disableOptionCentering panelClass="mobile-sheet-select"
                                                    [ngModel]="getTensiometreBound(1)"
                                                    [ngModelOptions]="{standalone: true}"
                                                    (ngModelChange)="setTensiometreBound(1, $event)"
                                                    [disabled]="optionsTensiometre.disabled">
                                            <mat-option *ngFor="let o of tensiometreMaxOptions" [value]="o.value">{{ o.label }}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <h2>Taux de locataires
                                <i class="fa fa-lock" (click)="unlock()"
                                   *ngIf="optionsTl.disabled"></i>
                            </h2>
                            <ng-container *ngTemplateOutlet="rangeInputsTpl; context: {control: 'tl', suffix: '%', locked: optionsTl.disabled}"></ng-container>
                        </div>
                        <div class="col-12 col-md-6">
                            <h2>Loyer au m²
                                <i class="fa fa-lock" (click)="unlock()"
                                   *ngIf="optionsSquareRent.disabled"></i>
                            </h2>
                            <ng-container *ngTemplateOutlet="rangeInputsTpl; context: {control: 'squareRent', suffix: '€/m²', locked: optionsSquareRent.disabled}"></ng-container>
                        </div>
                        <div class="col-12 col-md-6">
                            <h2>Prix au m²
                                <i class="fa fa-lock" (click)="unlock()"
                                   *ngIf="optionsSquarePriceCity.disabled"></i>
                            </h2>
                            <ng-container *ngTemplateOutlet="rangeInputsTpl; context: {control: 'squarePriceCity', suffix: '€/m²', locked: optionsSquarePriceCity.disabled}"></ng-container>
                        </div>
                        <div class="col-12 col-md-6">
                            <h2>Rentabilité moyenne de la ville
                                <i class="fa fa-lock" (click)="unlock()"
                                   *ngIf="optionsEfficiencyCity.disabled"></i>
                            </h2>
                            <ng-container *ngTemplateOutlet="rangeInputsTpl; context: {control: 'efficiencyCity', suffix: '%', locked: optionsEfficiencyCity.disabled}"></ng-container>
                        </div>
                    </div>
                </div>

                <div class="card" [hidden]="currentTab != 'price_evol'">
                    <div class="row">
                        <div class="col-12">
                            <div class="row">
                                <div class="col-12 col-md-3">
                                    <h2>Sur 1 an
                                        <i class="fa fa-lock" (click)="unlock()"
                                           *ngIf="optionsPriceEvolCity.disabled"></i></h2>
                                    <ng-container *ngTemplateOutlet="rangeInputsTpl; context: {control: 'priceEvolCity_1', suffix: '%', locked: optionsPriceEvolCity.disabled}"></ng-container>
                                </div>
                                <div class="col-12 col-md-3">
                                    <h2>Sur 3 ans
                                        <i class="fa fa-lock" (click)="unlock()"
                                           *ngIf="optionsPriceEvolCity.disabled"></i></h2>
                                    <ng-container *ngTemplateOutlet="rangeInputsTpl; context: {control: 'priceEvolCity_3', suffix: '%', locked: optionsPriceEvolCity.disabled}"></ng-container>
                                </div>
                                <div class="col-12 col-md-3">
                                    <h2>Sur 5 ans
                                        <i class="fa fa-lock" (click)="unlock()"
                                           *ngIf="optionsPriceEvolCity.disabled"></i></h2>
                                    <ng-container *ngTemplateOutlet="rangeInputsTpl; context: {control: 'priceEvolCity_5', suffix: '%', locked: optionsPriceEvolCity.disabled}"></ng-container>
                                </div>
                                <div class="col-12 col-md-3">
                                    <h2>Sur 10 ans
                                        <i class="fa fa-lock" (click)="unlock()"
                                           *ngIf="optionsPriceEvolCity.disabled"></i></h2>
                                    <ng-container *ngTemplateOutlet="rangeInputsTpl; context: {control: 'priceEvolCity_10', suffix: '%', locked: optionsPriceEvolCity.disabled}"></ng-container>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <!-- MOBILE : Effacer (la section) / Valider (retour aux catégories), barre fixe en bas -->
                <div class="container-fluid filters-actions">
                    <p class="filters-count text-center text-grey" *ngIf="citiesCount != null">
                        Votre recherche comporte {{ citiesCount | number }} ville{{ citiesCount > 1 ? 's' : '' }}
                    </p>
                    <div class="d-flex justify-content-between gap-3">
                        <button class="btn btn-lg btn-outline" type="button" (click)="resetCurrentTab()">
                            <i class="fa fa-refresh"></i> Effacer
                        </button>
                        <button class="btn btn-lg" type="button" (click)="mode = 'sidebar'">
                            <i class="fa fa-check"></i> Valider
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>

<ng-template #cityFilterTabsStepContent>
    <div class="user_onboarding_content">
        <h2>Définissez vos critères</h2>
        <p>
            C’est ici que vous allez construire votre <b>recherche de villes rentables</b>.<br/>
            <br/>
            Vous pouvez naviguer dans le menu de gauche pour définir vos critères de recherche.<br/>
            <br/>
            Dans un <b>premier temps</b>, vous allez devoir <b>choisir le secteur dans lequel chercher</b>, cela peut
            être :</p>
        <ul>
            <li>Jusqu’à 100 km autour d’une ville</li>
            <li>Dans un département ou une région</li>
        </ul>
        <p>
            Dans un <b>second temps</b>, vous allez <b>choisir les villes qui vous intéressent</b> dans ce secteur
            (nombre d’habitants minimums, nombre d’étudiants, etc …)
            Vous êtes prêt ? C’est parti !
        </p>
    </div>
</ng-template>

<ng-template #cityFilterCityStepContent>
    <div class="user_onboarding_content">
        <h2>1ère étape : La localisation</h2>
        <p>
            Ici, vous pouvez choisir une ou plusieurs villes et choisir un <b>rayon jusqu'à 100 km autour de chaque ville</b>
        </p>
    </div>
</ng-template>

<ng-template #cityFilterLocalisationStepContent>
    <div class="user_onboarding_content">
        <h2>1ère étape : La localisation</h2>
        <p>
            Enfin, vous pouvez aussi choisir des départements/régions pour votre recherche.<br/>
            <br/>
            Cela va s’ajouter aux villes précédemment sélectionnées.<br/>
            <br/>
            <b>Exemple</b> : En choisissant Ile de France + Orléans (10 km). Vous sélectionnerez toutes les villes en Ile de France et autour d'Orléans.<br/>
            <br/>
            <b>Astuce</b> : Vous pouvez sélectionner les villes éligibles au plan “Action cœur de ville” et au dispositif Denormandie 😉
        </p>
    </div>
</ng-template>

<ng-template #cityFilterSocioStepContent>
    <div class="user_onboarding_content">
        <h2>2ème étape : Filtrer les villes</h2>
        <p>
            Ensuite, vous devez choisir les filtres de sélection pour votre sélection de ville.<br/>
            <br/>
            Vous avez ici la liste des <b>filtres socio-démographiques</b> : Population, taux d’étudiant, etc …
        </p>
    </div>
</ng-template>

<ng-template #cityFilterImmoStepContent>
    <div class="user_onboarding_content">
        <h2>2ème étape : Filtrer les villes</h2>
        <p>
            Pour terminer, vous avez ici la liste des <b>filtres immobiliers</b> : Tension locative, prix au m², etc …<br/>
            <br/>
        </p>
    </div>
</ng-template>

<ng-template #cityFilterValidateStepContent>
    <div class="user_onboarding_content">
        <h2>Valider votre recherche</h2>
        <p>
            Cliquez ici pour accéder aux résultats de recherche.<br/>
            <br/>
            Vous pourrez <b>enregistrer</b> vos critères de recherche sur le prochain écran.<br/>
        </p>
    </div>
</ng-template>
